module.exports = "/packs/media/images/icons/analysis-33aa21de54eef6ac5d7569e6b277acf5.png";